// Visitor-facing glosses required by Transbank's Autoservicio homologation
// workbook (SET DE PRUEBAS POS Autoservicio 280524): each decline code the
// workbook exercises must surface its recommended wording, verbatim.
//
// Sibling of the counter's table in
// packages/entradart-web/app/lib/pos/pos-glosses.ts, trimmed to the codes a
// self-service sale can actually produce (no anulación / detalle de ventas
// here) and keyed by the IM30's two-digit string codes instead of the SDK's
// numbers.

const RECOMMENDED_GLOSSES: Record<string, string> = {
  // Tarjeta de crédito pasada por el menú de débito o viceversa (casos 27/28).
  "01": "Error en selección de tipo tarjeta, reintentar",
  // El POS no alcanzó a Transbank: sin internet (caso 24).
  "03": "Reintente - Conexión falló",
  // Venta liberada por timeout o botón rojo en el POS (casos 8-18).
  "07": "Reintente Transacción",
  "18": "Error en selección de tipo tarjeta, reintentar",
  "22": "Reintente Transacción",
};

// Required wording when the POS never answers: venta sin respuesta, POS
// desconectado o sin electricidad (casos 23, 25, 26).
export const NO_POS_COMMUNICATION = "No existe comunicación con POS";

export function declineGloss(responseCode: string): string {
  return (
    RECOMMENDED_GLOSSES[responseCode] ??
    `Tarjeta rechazada (código ${responseCode})`
  );
}

// Codes where the likeliest real-world cause at an unattended totem is a
// foreign or PIN-less card the Autoservicio IM30 cannot process (it forbids
// signature CVM and limits no-PIN credit). 01 = generic "Rechazado",
// 06 = tarjeta no soportada, 12 = transacción no soportada.
const FOREIGN_CARD_HINT_CODES = new Set(["01", "06", "12"]);

export function hintKeyForDecline(responseCode: string): "hintForeignCard" | undefined {
  return FOREIGN_CARD_HINT_CODES.has(responseCode) ? "hintForeignCard" : undefined;
}
